import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { PostmarkBounceWebHookData } from '@lemon/core-firebase/model/lasku'

export interface LaskuKokoVirheDialogData {
  virhe: PostmarkBounceWebHookData
}

@Component({
  selector: 'lasku-koko-virhe-dialog',
  templateUrl: './lasku.koko-virhe.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuKokoVirheDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LaskuKokoVirheDialogData,
    private dialogRef: MatDialogRef<LaskuKokoVirheDialog>,
  ) {}

  ngOnInit() {}
}
